module.exports = __webpack_public_path__ + "media/icon/icon-door-lock-box-gray-28158013.svg";